import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";
import { IClinicSalesItems, ClinicSalesItems, ISalesItemModel, SalesItemModel, SalesItemSimpleListingModel, ISalesItemSimpleListingModel, ISalesItemUpgradeListingModel, SalesItemUpgradeListingModel } from "@common/models";
import { DateTime } from "luxon";
export class SalesItemService {
    private static baseUrl: string = '/api/salesItem';

    public static tags = {
        fetchSalesItems: "fetchSalesItems",
        getSalesItemOptions: "getSalesItemOptions",
        getSalesItem: "getSalesItem",
        upsertSalesItem: "upsertSalesItem",
        deleteSalesItem: "deleteSalesItem",
        getSalesItemsAvailableForUpgradeSelection: "getSalesItemsAvailableForUpgradeSelection"
    }

    static fetchSalesItems = (clinicId: number, clinicDate: DateTime): Promise<ClinicSalesItems> => {
        return trackPromise(new Promise<ClinicSalesItems>((resolve, reject) => {
            http(`${this.baseUrl}/${clinicDate.toISODate()}/clinic/${clinicId}`)
                .getVersioned<IClinicSalesItems>(`sales-items-${clinicDate.toISODate()}-${clinicId}`)
                .then((response) => resolve(new ClinicSalesItems(response)))
                .catch(reject)
        }), this.tags.fetchSalesItems);
    }

    static getSalesItemOptions = (businessLineId?: number): Promise<ISalesItemSimpleListingModel[]> => {
        const optionUrl = (businessLineId === null ? `${this.baseUrl}/options` : `${this.baseUrl}/options/${businessLineId}`)
        return trackPromise(new Promise<ISalesItemSimpleListingModel[]>((resolve, reject) => {
            http(optionUrl).get<ISalesItemSimpleListingModel[]>()
                .then((response) => response.map(mm => new SalesItemSimpleListingModel(mm)))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.getSalesItemOptions);
    }

    static getSalesItemById = (salesItemId: number): Promise<ISalesItemModel> => {
        return trackPromise(new Promise<ISalesItemModel>((resolve, reject) => {
            http(`${this.baseUrl}/${salesItemId}`).get<ISalesItemModel>()
                .then((response) => new SalesItemModel(response))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.getSalesItem);
    };

    static upsertSalesItem = (data: ISalesItemModel): Promise<SalesItemModel> => {
        return trackPromise(new Promise<SalesItemModel>((resolve, reject) => {
            http(`${this.baseUrl}`).post<ISalesItemModel>(data)
                .then((response) => new SalesItemModel(response))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.upsertSalesItem);
    }

    static deleteSalesItem = (salesItemId: number): Promise<boolean> => {
        return trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}/${salesItemId}`).delete()
                .then(() => {
                    resolve(true);
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.deleteSalesItem);
    }

    static getSalesItemsAvailableForUpgradeSelection = (salesItemId: number): Promise<ISalesItemUpgradeListingModel[]> => {
        return trackPromise(new Promise<ISalesItemUpgradeListingModel[]>((resolve, reject) => {
            http(`${this.baseUrl}/getsalesitemsavailableforupgradeselection/${salesItemId}`).get<ISalesItemModel[]>()
                .then((response) => response.map(mm => new SalesItemUpgradeListingModel(mm)))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.getSalesItemsAvailableForUpgradeSelection);
    };


}
